// Helpers to build JSON-LD structured data objects used across the site.
const SITE_URL = process.env.REACT_APP_SITE_URL;
if (!SITE_URL) throw new Error("REACT_APP_SITE_URL is required");

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "E-Com Benchmark Lab",
  url: SITE_URL,
  description: "E-Com Benchmark Lab publishes disclosed, criteria-led editorial comparisons of ecommerce platforms using a 55-criterion framework.",
  publishingPrinciples: `${SITE_URL}/editorial-policy`,
  sameAs: [],
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "E-Com Benchmark Lab",
  url: SITE_URL,
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: f.a,
    },
  })),
});

export const itemListSchema = (name, items) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name,
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    url: `${SITE_URL}${item.path}`,
  })),
});

export const platformReviewSchema = (platform) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  url: `${SITE_URL}/${platform.slug}-review`,
  headline: `${platform.name} Evidence Review`,
  description: `${platform.name} claim-level source register across 55 ecommerce platform criteria. Numeric scores are withheld.`,
  about: {
    "@type": "SoftwareApplication",
    name: platform.name,
    url: platform.website,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
  },
  author: { "@type": "Organization", name: "E-Com Benchmark Lab", url: SITE_URL },
  publisher: { "@type": "Organization", name: "E-Com Benchmark Lab", url: SITE_URL },
  datePublished: "2026-09-18",
  dateModified: "2026-09-18",
  isBasedOn: {
    "@type": "CreativeWork",
    name: "E-Com Benchmark Lab 2026 methodology",
    url: `${SITE_URL}/methodology`,
  },
});

export const articleSchema = ({ headline, description, path, datePublished = "2026-09-18", dateModified = "2026-09-18" }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline,
  description,
  url: `${SITE_URL}${path}`,
  datePublished,
  dateModified,
  author: { "@type": "Organization", name: "E-Com Benchmark Lab" },
  publisher: { "@type": "Organization", name: "E-Com Benchmark Lab" },
});
